import React from "react";

const HierarchyUpArrowSvg = (): JSX.Element => {
  return (
    <svg
      width="10px"
      height="14px"
      viewBox="0 0 10 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Icons/Expand/Down</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Manager-Report---Summary-Copy-3"
          transform="translate(-60.000000, -420.000000)"
          fill="#0073BB"
        >
          <g
            id="Headcount-plan-data"
            transform="translate(35.000000, 342.000000)"
          >
            <g id="Group-3" transform="translate(0.000000, 60.000000)">
              <g
                id="table-/-header-/-cell-/-default"
                transform="translate(20.000000, 0.000000)"
              >
                <g id="table-/-default-/-header-row">
                  <g id="Group" transform="translate(0.000000, 15.000000)">
                    <g id="Icons/Arrow/Up">
                      <g
                        id="Icons/upload"
                        transform="translate(5.000000, 3.000000)"
                      >
                        <path
                          d="M5,0.292893219 L9.35355339,4.64644661 L8.64644661,5.35355339 L5.49944661,2.20689322 L5.5,14 L4.5,14 L4.49944661,2.20689322 L1.35355339,5.35355339 L0.646446609,4.64644661 L5,0.292893219 Z"
                          id="Combined-Shape"
                          fillRule="nonzero"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default HierarchyUpArrowSvg;
